/* =========================================================
   BLACKOUT — Product Page JS v7
   Optimistic Add to Cart + Horizon cart bubble fix
   ========================================================= */

var BOP_VARIANTS = [];
var BOP_SELECTED = {};

/* =========================================================
   CAPTURE PHASE LISTENER
   Intercepts BLACKOUT product-page controls before theme handlers
   ========================================================= */
document.addEventListener('click', function (e) {
  var el = e.target.closest('[data-bop]');
  if (!el) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var action = el.dataset.bop;

  if (action === 'atc')       { bopDoAddToCart(el); return; }
  if (action === 'buynow')    { bopDoBuyNow(el);    return; }
  if (action === 'select')    { bopDoSelect(el);     return; }
  if (action === 'inc')       { bopDoQty(el, 1);     return; }
  if (action === 'dec')       { bopDoQty(el, -1);    return; }
  if (action === 'thumb')     { bopDoThumb(el);      return; }

  if (action === 'zoom') {
    document.getElementById('bop-main-img-wrap')?.classList.toggle('zoomed');
    return;
  }

  if (action === 'accordion') {
    bopDoAccordion(el);
    return;
  }
}, true);


/* =========================================================
   INIT
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  try {
    var el = document.getElementById('bop-variants-json');
    if (el) BOP_VARIANTS = JSON.parse(el.textContent);
  } catch (_) {}

  document.querySelectorAll('.bop-opt-btn.active').forEach(function (btn) {
    BOP_SELECTED[btn.dataset.option] = btn.dataset.value;
  });

  document.querySelectorAll('.bop-thumb').forEach(function (t) {
    t.dataset.bop = 'thumb';
  });

  var zoomBtn = document.querySelector('.bop-zoom-btn');
  if (zoomBtn) zoomBtn.dataset.bop = 'zoom';

  document.querySelectorAll('.bop-accordion-btn').forEach(function (b) {
    b.dataset.bop = 'accordion';
  });

  function removePayPal() {
    var page = document.querySelector('.bop-page');
    if (!page) return;

    page
      .querySelectorAll(
        '.shopify-payment-button,.dynamic-checkout-cart,[data-shopify="payment-button"]'
      )
      .forEach(function (el) {
        el.remove();
      });
  }

  removePayPal();
  setTimeout(removePayPal, 600);
  setTimeout(removePayPal, 1500);
});


/* =========================================================
   ACTIONS
   ========================================================= */

function bopDoThumb(thumb) {
  document.querySelectorAll('.bop-thumb').forEach(function (t) {
    t.classList.remove('active');
  });

  thumb.classList.add('active');

  var img = document.getElementById('bop-main-img');

  if (img && thumb.dataset.src) {
    img.src = thumb.dataset.src;
    img.srcset = '';
  }

  document.getElementById('bop-main-img-wrap')?.classList.remove('zoomed');
}


function bopDoAccordion(btn) {
  var item = btn.closest('.bop-accordion-item');
  if (!item) return;

  var isOpen = item.classList.contains('open');

  document.querySelectorAll('.bop-accordion-item.open').forEach(function (i) {
    i.classList.remove('open');
  });

  if (!isOpen) item.classList.add('open');
}


function bopDoQty(btn, delta) {
  var input = btn.closest('.bop-qty')?.querySelector('.bop-qty__input');
  if (!input) return;

  var current = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, Math.min(99, current + delta));
}


function bopDoSelect(btn) {
  var group = btn.dataset.option;

  document
    .querySelectorAll('.bop-opt-btn[data-option="' + group + '"]')
    .forEach(function (b) {
      b.classList.remove('active');
    });

  btn.classList.add('active');
  BOP_SELECTED[group] = btn.dataset.value;

  var match = BOP_VARIANTS.find(function (v) {
    var opts = [v.option1, v.option2, v.option3].filter(Boolean);

    return Object.values(BOP_SELECTED).every(function (val, i) {
      return opts[i] === val;
    });
  });

  if (!match) return;

  var input = document.getElementById('bop-variant-id');
  if (input) input.value = match.id;

  var priceEl = document.getElementById('bop-price-display');

  if (priceEl) {
    try {
      priceEl.textContent = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify?.currency?.active) || 'EGP'
      }).format(match.price / 100);
    } catch (_) {
      priceEl.textContent = match.price / 100;
    }
  }

  var atc = document.getElementById('bop-atc');
  var sticky = document.getElementById('bop-sticky-btn');
  var buyNow = document.getElementById('bop-buynow');

  var icon =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" ' +
    'stroke-linejoin="round" style="margin-right:7px">' +
    '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
    '<line x1="3" y1="6" x2="21" y2="6"/>' +
    '<path d="M16 10a4 4 0 01-8 0"/>' +
    '</svg>';

  if (match.available) {
    if (atc) {
      atc.disabled = false;
      atc.innerHTML = icon + 'Add to cart';
    }

    if (sticky) {
      sticky.disabled = false;
      sticky.textContent = 'Add to cart';
    }

    if (buyNow) {
      buyNow.style.display = '';
      buyNow.dataset.variantId = match.id;
    }
  } else {
    if (atc) {
      atc.disabled = true;
      atc.textContent = 'Sold Out';
    }

    if (sticky) {
      sticky.disabled = true;
      sticky.textContent = 'Sold Out';
    }

    if (buyNow) {
      buyNow.style.display = 'none';
    }
  }

  if (match.featured_image) {
    var img = document.getElementById('bop-main-img');

    if (img) {
      img.src = match.featured_image.src;
      img.srcset = '';
    }
  }
}


/* =========================================================
   ADD TO CART
   ========================================================= */

function bopDoAddToCart(btn) {
  var variantId = document.getElementById('bop-variant-id')?.value;

  var qty = parseInt(
    document.querySelector('.bop-qty__input')?.value || '1',
    10
  );

  if (!variantId || btn.disabled) return;
  if (!Number.isFinite(qty) || qty < 1) qty = 1;

  var origHTML = btn.innerHTML;
  var previousCount = bopGetCurrentCount();

  /*
   * INSTANT UI UPDATE
   */
  btn.disabled = true;
  btn.innerHTML = 'Added ✓';
  btn.classList.add('bop-added');

  bopUpdateCount(previousCount + qty);

  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: qty
    })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'Unable to add this product to cart.'
          );
        }

        return data;
      });
    })

    .then(function (item) {
      /*
       * Shopify confirmed successful addition
       */
      bopShowNotif(item.title || 'Item added');

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            source: 'blackout-product',
            item: item,
            quantity: qty
          }
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            source: 'blackout-product'
          }
        })
      );

      setTimeout(function () {
        btn.classList.remove('bop-added');
        btn.innerHTML = origHTML;
        btn.disabled = false;
      }, 800);
    })

    .catch(function (error) {
      console.error('BLACKOUT Add to cart error:', error);

      /*
       * Roll back count if Shopify rejected request
       */
      bopUpdateCount(previousCount);

      btn.classList.remove('bop-added');
      btn.innerHTML = origHTML;
      btn.disabled = false;

      bopShowError(
        error.message || 'Could not add product to cart.'
      );
    });
}


/* =========================================================
   BUY NOW
   ========================================================= */

function bopDoBuyNow(btn) {
  var variantId = document.getElementById('bop-variant-id')?.value;

  var qty = parseInt(
    document.querySelector('.bop-qty__input')?.value || '1',
    10
  );

  if (!variantId) {
    window.location.href = '/checkout';
    return;
  }

  if (!Number.isFinite(qty) || qty < 1) qty = 1;

  btn.textContent = 'Processing...';
  btn.disabled = true;

  var root =
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: qty
    })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(
            data.description ||
            data.message ||
            'Unable to continue to checkout.'
          );
        });
      }

      window.location.href = root + 'checkout';
    })

    .catch(function (error) {
      console.error('BLACKOUT Buy Now error:', error);

      btn.disabled = false;
      btn.textContent = 'Buy it now';

      bopShowError(
        error.message || 'Could not continue to checkout.'
      );
    });
}


/* =========================================================
   CART COUNT
   ========================================================= */

function bopGetCurrentCount() {
  var countEl = document.querySelector(
    '.cart-bubble__text-count'
  );

  if (!countEl) return 0;

  var text = countEl.textContent || '0';
  var match = text.match(/\d+/);

  return match
    ? parseInt(match[0], 10) || 0
    : 0;
}


function bopUpdateCount(count) {

  /*
   * HORIZON FIX:
   * Horizon hides the bubble when cart is empty.
   */

  document.querySelectorAll('.cart-bubble').forEach(function (bubble) {

    if (count > 0) {
      bubble.classList.remove('visually-hidden');
      bubble.removeAttribute('hidden');
    } else {
      bubble.classList.add('visually-hidden');
    }

    bubble.classList.remove(
      'cart-bubble--animating'
    );

    void bubble.offsetWidth;

    if (count > 0) {
      bubble.classList.add(
        'cart-bubble--animating'
      );

      setTimeout(function () {
        bubble.classList.remove(
          'cart-bubble--animating'
        );
      }, 600);
    }
  });


  document
    .querySelectorAll('.cart-bubble__text-count')
    .forEach(function (el) {

      el.textContent =
        count > 99
          ? '99+'
          : count > 0
            ? String(count)
            : '';

      if (count > 0) {
        el.classList.remove('hidden');
        el.removeAttribute('hidden');
      } else {
        el.classList.add('hidden');
      }
    });


  document.querySelectorAll('cart-icon').forEach(function (el) {
    el.classList.toggle(
      'header-actions__cart-icon--has-cart',
      count > 0
    );
  });
}


/* =========================================================
   NOTIFICATION
   ========================================================= */

function bopShowNotif(title) {
  var notif =
    document.getElementById('bop-notif');

  var titleEl =
    document.getElementById('bop-notif-title');

  if (!notif) return;

  if (titleEl) {
    titleEl.textContent = title;
  }

  notif.style.bottom = '28px';

  clearTimeout(notif._t);

  notif._t = setTimeout(function () {
    notif.style.bottom = '-100px';
  }, 3000);
}


/* =========================================================
   ERROR NOTIFICATION
   ========================================================= */

function bopShowError(message) {
  var notif =
    document.getElementById('bop-notif');

  var titleEl =
    document.getElementById('bop-notif-title');

  if (!notif) {
    console.error(message);
    return;
  }

  if (titleEl) {
    titleEl.textContent = message;
  }

  notif.style.bottom = '28px';

  clearTimeout(notif._t);

  notif._t = setTimeout(function () {
    notif.style.bottom = '-100px';
  }, 3500);
}